import { Reducer } from 'redux';

import {
  QuestionActivityDetailsLoadFulfilledAction,
  QuestionActivityDetailsLoadPendingAction,
  QuestionActivityDetailsLoadRejectedAction,
} from '../../domains/questionActivityDetails/actions.types';
import { moveToFulfilled, moveToPending, moveToRejected } from '../types';

import { QuestionActivityDetailsEntities } from './types';

export type QuestionActivityDetailsLoadAction =
  | QuestionActivityDetailsLoadPendingAction
  | QuestionActivityDetailsLoadFulfilledAction
  | QuestionActivityDetailsLoadRejectedAction;

const initialState: QuestionActivityDetailsEntities = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<QuestionActivityDetailsEntities, QuestionActivityDetailsLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'QUESTION_ACTIVITY_DETAILS.LOAD_PENDING':
      return moveToPending(state, [action.payload.groupId]);
    case 'QUESTION_ACTIVITY_DETAILS.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.groupId], action.payload.error);
    case 'QUESTION_ACTIVITY_DETAILS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groupQuestionActivity);
    default:
      return state;
  }
};

export default reducer;
